<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'TransportTypesPage',
};
</script>

<style>

</style>
